import { Grid, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import ThemeLogo from 'src/common/components/theme-logo/theme-logo';
import { AppState } from 'src/common/redux/configure-store';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { styles } from './customer-display-thank-you-styles';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'src/emerald-theme-provider';
import { StateConfig } from 'src/common/interfaces/dtos/ITouchpointTheme';
import clsx from 'clsx';
import CustomerCartLogo from 'src/common/components/cart-icon/customer-cart-image';

const CustomerDisplayThankYou: React.FC<ReturnType<typeof mapStateToProps>> = ({
  changeDue,
  cashBack,
}) => {
  const { emeraldTheme } = useContext(ThemeContext);
  const changeDueStyles = emeraldTheme?.customerDisplay?.changeDue;
  const changeDueProps: StateConfig = {
    backgroundColor: changeDueStyles?.backgroundColor,
    backgroundImageURL: changeDueStyles?.backgroundImageURL,
    bodyTextColor: changeDueStyles?.bodyTextColor,
    headingTextColor: changeDueStyles?.headingTextColor,
  };
  const trainingModeActive = useSelector((state: AppState): boolean => state.posMode.trainingMode);
  const emailReceiptRequested = useSelector(
    (state: AppState): boolean => !!state.tendering.digitalReceiptOptions.emailRequested,
  );
  const smsReceiptRequested = useSelector(
    (state: AppState): boolean => !!state.tendering.digitalReceiptOptions.phoneRequested,
  );
  const digitalReceiptRequested = emailReceiptRequested || smsReceiptRequested;
  const [moneyBack, setMoneyBack] = useState('');
  const [code, setCode] = useState('NoChange_CustomerDisplay_ThankYou');
  const grandTotal = useSelector((state: AppState): number => state.tendering.grandTotal);
  const { t } = useTranslation();

  // TODO: Move this somewhere else. This is copy+pasted code
  // from the XLR one and I would love to not do that
  useEffect(() => {
    if (cashBack) {
      setMoneyBack(convertCurrency(cashBack));
      setCode('CustomerDisplay_Cashback');
    } else {
      setMoneyBack(convertCurrency(changeDue));
      grandTotal > 0 ? setCode('CustomerDisplay_ChangeDue') : setCode('CustomerDisplay_Refund');
    }
  }, [changeDue, cashBack, grandTotal]);

  const classes = styles(changeDueProps);

  const trainingModeWatermark = trainingModeActive ? (
    <Grid data-testid='customer-display-training-watermark'>
      <TrainingModeWatermark supplementalStyles={classes.trainingWaterMark} />
    </Grid>
  ) : null;
  return (
    <Grid
      container
      data-testid='customer-display-thank-you'
      className={clsx(
        'fullWidth',
        'fullHeight',
        trainingModeActive ? classes.trainingModeBackground : classes.themeBackground,
      )}
      justifyContent='center'
      direction='column'
      alignItems='center'
    >
      {trainingModeWatermark}
      <Grid
        container
        direction='column'
        alignItems='center'
        justifyContent='center'
        className={classes.thankYouContainer}
      >
        <Grid item className={classes.line}>
          <CustomerCartLogo styles={classes.customerCartLogo} />
        </Grid>
        <Grid item>
          <Typography className={classes.title} data-testid='customer-display-thank-you-message'>
            {t(code)}
          </Typography>
        </Grid>
        <Grid item>
          <Typography data-testid='customer-display-thank-you-moneyback' className={classes.amount}>
            {moneyBack}
          </Typography>
        </Grid>
        <Grid item>
          <div className={`${classes.bar} ${classes.barNotification}`} />
        </Grid>
        <Grid item className={classes.subTitleContainer}>
          <Typography data-testid='customer-display-receipt-message' className={classes.subtitle}>
            {digitalReceiptRequested
              ? t('CashPaymentChangeView_Digital_Receipt_CustomerDisplayGoodbye')
              : t('CashPaymentChangeView_CustomerDisplayGoodbye')}
          </Typography>
        </Grid>
      </Grid>
      <Grid item className={classes.line}>
        <ThemeLogo styles={`${classes.logo}`} />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: AppState) => ({
  changeDue: state.tendering.changeDue,
  cashBack: state.tendering.cashback,
});

export default connect(mapStateToProps)(CustomerDisplayThankYou);
